export const en = {
    'auto-overdraft-sum-interval':
        'Incorrect value for the deactivation threshold. The amount must be from {minSum} {currency} to {maxSum} {currency}',
    'balance-unavailable-exception': 'Something went wrong. Try again.',
    'bank-payment': 'Bank transfer',
    'cannot-be-null': 'Enter a value',
    'card-payment': 'Bank card',
    'general-error': 'Something went wrong. Try again.',
    'no-rights-for-edit-auto-overdraft': 'No access rights to change the deactivation threshold',
    'no-rights-for-edit-wallet': 'No access rights to change the deactivation threshold',
    'paypal-wallet-payment': 'PayPal',
    'too-big-payment':
        'With the "{paymentMethodName}" payment method, the deactivation threshold cannot be less than -{maxSum} {currency}.',
    'wallet-sum-must-be-not-null': 'The account balance must be greater than 0',
    'webmoney-wallet-payment': 'WebMoney (WMR)',
    'yamoney-wallet-payment': 'Yandex.Money',
    'ynd-fixed-currency-error': 'Setting the deactivation threshold is not allowed for the selected currency'
};
